import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-notifypopup',
  templateUrl: './notifypopup.component.html',
  styleUrls: ['./notifypopup.component.scss']
})
export class NotifypopupComponent implements OnInit {
  message: any;
  width: any;
  height: any;

  constructor(private authService: AuthenticationService,
    private dialogRef: MatDialogRef<NotifypopupComponent>,
  ) { }

  ngOnInit(): void {
    this.getNotify()
  }

  getNotify() {
    var data = {
      keys: ["cardholder_announcement"]
    }
    this.authService.getNotification(data).subscribe((res) => {
      this.message = res.cardholder_announcement //show popup message 
      this.width = res.xero_status
      this.height = Number(res.voucher_status);
    })
  }

  close() {
    this.dialogRef.close();
  }

}
